import { render } from "./CategorieView.vue?vue&type=template&id=3a8f3758"
import script from "./CategorieView.vue?vue&type=script&lang=js"
export * from "./CategorieView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__